import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';
import './Analytics.css';

const hourlyData = [
  { hour: '00', patrols: 12 }, { hour: '02', patrols: 8 }, { hour: '04', patrols: 5 },
  { hour: '06', patrols: 22 }, { hour: '08', patrols: 45 }, { hour: '10', patrols: 68 },
  { hour: '12', patrols: 72 }, { hour: '14', patrols: 65 }, { hour: '16', patrols: 70 },
  { hour: '18', patrols: 80 }, { hour: '20', patrols: 58 }, { hour: '22', patrols: 34 },
];

const zoneData = [
  { name: 'East Zone', active: 312, color: '#22c55e' },
  { name: 'West Zone', active: 284, color: '#3b82f6' },
  { name: 'North Zone', active: 246, color: '#f59e0b' },
  { name: 'Central Zone', active: 236, color: '#a855f7' },
];

const responseData = [
  { day: 'Mon', time: 5.2 }, { day: 'Tue', time: 4.8 }, { day: 'Wed', time: 4.2 },
  { day: 'Thu', time: 4.6 }, { day: 'Fri', time: 3.9 }, { day: 'Sat', time: 5.1 }, { day: 'Sun', time: 4.5 },
];

const Analytics = () => (
  <div className="analytics-page">
    <div className="page-header">
      <h2>Analytics &amp; Reports</h2>
    </div>
    <div className="analytics-grid">
      <div className="chart-card">
        <div className="chart-title">Hourly Patrol Activity</div>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={hourlyData}>
            <XAxis dataKey="hour" stroke="#64748b" fontSize={11} />
            <YAxis stroke="#64748b" fontSize={11} />
            <Tooltip contentStyle={{ background: '#112240', border: '1px solid #1e3a5f', color: '#e2e8f0', fontSize: 12 }} />
            <Bar dataKey="patrols" fill="#3b82f6" radius={[3,3,0,0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="chart-card">
        <div className="chart-title">Avg. Response Time (mins) – Last 7 Days</div>
        <ResponsiveContainer width="100%" height={200}>
          <LineChart data={responseData}>
            <XAxis dataKey="day" stroke="#64748b" fontSize={11} />
            <YAxis stroke="#64748b" fontSize={11} />
            <Tooltip contentStyle={{ background: '#112240', border: '1px solid #1e3a5f', color: '#e2e8f0', fontSize: 12 }} />
            <Line type="monotone" dataKey="time" stroke="#22c55e" strokeWidth={2} dot={{ fill: '#22c55e', r: 4 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="chart-card">
        <div className="chart-title">Zone-Wise Active Personnel</div>
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie data={zoneData} dataKey="active" nameKey="name" cx="50%" cy="50%" outerRadius={80} innerRadius={50} paddingAngle={3}>
              {zoneData.map((entry, i) => <Cell key={i} fill={entry.color} />)}
            </Pie>
            <Tooltip contentStyle={{ background: '#112240', border: '1px solid #1e3a5f', color: '#e2e8f0', fontSize: 12 }} />
          </PieChart>
        </ResponsiveContainer>
        <div className="pie-legend">
          {zoneData.map(z => (
            <span key={z.name} className="pie-legend-item">
              <span className="pie-dot" style={{ background: z.color }}></span>{z.name}: {z.active}
            </span>
          ))}
        </div>
      </div>
      <div className="chart-card">
        <div className="chart-title">Unit Distribution</div>
        <div className="unit-bars">
          {[
            { label: 'Law & Order', count: 512, color: '#3b82f6', total: 982 },
            { label: 'Traffic Police', count: 228, color: '#22c55e', total: 982 },
            { label: 'Patrol Units', count: 162, color: '#a855f7', total: 982 },
            { label: 'Special Units', count: 80, color: '#f59e0b', total: 982 },
          ].map(u => (
            <div key={u.label} className="unit-bar-row">
              <div className="unit-bar-label">{u.label}</div>
              <div className="unit-bar-track">
                <div className="unit-bar-fill" style={{ width: `${(u.count / u.total) * 100}%`, background: u.color }}></div>
              </div>
              <div className="unit-bar-count">{u.count}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Analytics;
